<template>
  <div class="w-container">
    <div class="top-title" v-if="!compareUnit">
      <span v-if="unitParams.type !== 4">{{
        generatorInfo.name ? generatorInfo.name : '--'
      }}</span>
      <span v-else>{{ tubeInfo.name ? tubeInfo.name : '--' }}</span>
    </div>
    <div class="top-title" v-else>
      <span>对比</span>
    </div>
    <div v-if="!compareUnit">
      <el-table
        :data="unitTableData"
        v-loading="tableLoading"
        style="width: 100%"
        :height="unitParams.type === 3 ? 0 : tableHeight"
        size="mini"
        border
        v-if="
          unitParams.type === 1 ||
            unitParams.type === 2 ||
            unitParams.type === 5
        "
        key="1"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="quota" label="项目" width="180">
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="160">
        </el-table-column>
        <el-table-column label="数值" prop="value"> </el-table-column>
      </el-table>

      <!-- 线缆表格 -->
      <el-table
        :data="unitTableData"
        border
        key="42"
        v-if="unitParams.type === 3"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :span-method="assemblyObjectMethod"
        :header-cell-class-name="tableRowClassName1"
      >
        <el-table-column label="序号" prop="number" align="center" width="60">
        </el-table-column>
        <el-table-column label="项目">
          <el-table-column prop="names"> </el-table-column>
          <el-table-column prop="name"> </el-table-column>
        </el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
        <el-table-column label="数值" prop="value"> </el-table-column>
      </el-table>

      <!--塔筒详情表格-->
      <el-table
        v-if="unitParams.type === 4"
        :data="unitTableData"
        v-loading="tableLoading"
        style="width: 100%"
        size="mini"
        border
        key="2"
        :span-method="unitTableDataMethod"
        :header-cell-class-name="tableRowClassName1"
        :summary-method="getSummaries"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          prop="number"
          label="序号"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column label="项目">
          <el-table-column prop="tubeName" align="center"></el-table-column>
          <el-table-column prop="name" align="center"></el-table-column>
        </el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="value" label="数值"></el-table-column>
      </el-table>
    </div>

    <div v-else>
      <el-table
        :data="unitTableCompareData"
        v-loading="tableCompareLoading"
        style="width: 100%"
        :height="tableHeight"
        size="mini"
        border
        v-if="
          currentUnitType === 1 ||
            currentUnitType === 2 ||
            currentUnitType === 5
        "
        key="3"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="quota" label="指标" width="180">
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="180">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :label="item.label"
          :key="index"
          :prop="item.prop"
        >
        </el-table-column>
      </el-table>

      <el-table
        :data="unitTableCompareData"
        border
        key="4"
        v-if="currentUnitType === 3"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :span-method="assemblyObjectMethod"
        :header-cell-class-name="tableRowClassName1"
      >
        <el-table-column prop="number" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column label="项目">
          <el-table-column prop="names"> </el-table-column>
          <el-table-column prop="name"> </el-table-column>
        </el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :label="item.label"
          :key="index"
          :prop="item.prop"
        >
        </el-table-column>
      </el-table>

      <el-table
        :data="unitTableCompareData"
        border
        key="5"
        v-if="currentUnitType === 4"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :span-method="unitTableDataMethod1"
        :header-cell-class-name="tableRowClassName1"
      >
        <el-table-column
          prop="number"
          label="序号"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column label="项目">
          <el-table-column prop="tubeName" align="center"></el-table-column>
          <el-table-column prop="name" align="center"></el-table-column>
        </el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :label="item.label"
          :key="index"
          :prop="item.prop"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  filterUnitTableData,
  filterCompareUnit,
  filterCompareUnit4
} from '../helper/filter';
import { UNIT_TYPE } from '../helper/unitData';
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {},
  data() {
    return {
      generatorInfo: {},
      unitTableData: [],
      tableLoading: false,
      tableCompareLoading: false,
      tubeDetail: [],
      tubeInfo: {},
      // 对比部件详情的数据
      unitTableCompareData: [],
      tableList: [],
      unitTypes: UNIT_TYPE,
      // 部件对比的时候的ID和部件类型
      unitIds: [],
      currentUnitType: null
    };
  },
  computed: {
    ...mapState('model', ['unitParams', 'compareUnit', 'unitCheckedList']),
    tableHeight() {
      return window.innerHeight - 108;
    },
    columns() {
      if (isEmpty(this.tableList)) return [];
      const cols = [];
      this.tableList.forEach((eco, i) => {
        cols.push({
          label: eco.name,
          prop: `value${i === 0 ? '' : i}`
        });
      });
      return cols;
    }
  },
  watch: {
    unitParams(val) {
      if (typeof val === 'object' && Object.keys(val).length <= 0) {
        this.unitTableData = [];
        this.tubeDetail = [];
        this.generatorInfo = {};
        this.tubeInfo = {};
        return;
      }
      this.tableLoading = false;
      this.fetchGenerator();
    },
    compareUnit(val) {
      if (val) {
        this.fetchCompareInfo();
      }
    },
    unitCheckedList(val) {
      this.unitTableCompareData = [];
      this.tableList = [];
      if (val.length > 1) {
        this.currentUnitType = val[0].type;
        this.unitIds = val.map(item => {
          return item.pointId;
        });
        if (this.compareUnit) {
          this.fetchCompareInfo();
        }
      }
    }
  },
  methods: {
    // 部件数据塔筒对比表格单元格合并
    unitTableDataMethod1({ row, columnIndex }) {
      if (columnIndex === 0) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [1, 1];
        }
        if (row.tubeName && row.name === '长度') {
          return [5, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 1) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [1, 2];
        } else if (row.tubeName && row.name === '长度') {
          return [5, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 3) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [0, 0];
        }
      }
    },
    // 部件塔筒详情合并单元格
    unitTableDataMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [1, 1];
        }
        if (row.tubeName && row.name === '长度') {
          return [5, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 1) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [1, 2];
        } else if (row.tubeName && row.name === '长度') {
          return [5, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 3) {
        if (
          row.number === 1 ||
          row.number === 2 ||
          row.number === 3 ||
          row.tubeName === '附件'
        ) {
          return [0, 0];
        }
      }
    },
    // 部件线缆
    tableRowClassName1({ row }) {
      console.log;
      if (row.length === 2) {
        return 'dis';
      } else {
        row.forEach(item => {
          if (item.label === '项目') {
            return 'border-b';
          }
        });
      }
    },
    // 部件线缆单元格合并方法
    assemblyObjectMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        if (row.names && row.names !== '母线型式') {
          return [2, 1];
        } else {
          if (row.number === 1) {
            return [1, 1];
          } else if (row.names === '母线型式') {
            return [1, 1];
          } else {
            return [0, 0];
          }
        }
      } else if (columnIndex === 1) {
        if (row.names === '母线型式' && row.number === 4) {
          return [1, 2];
        } else if (row.names) {
          return [2, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 3) {
        if (row.names === '母线型式' && row.number === 4) {
          return [0, 0];
        }
      }
      // if (row.names && row.names !== '母线型式' && row.names !== '线缆名称') {
      //   return [2, 1];
      // } else {
      //   if (row.names === '线缆名称') {
      //     return [1, 2];
      //   } else if (row.names === '母线型式' && row.number === 5) {
      //     return [1, 1];
      //   } else {
      //     return [0, 0];
      //   }
      // }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '总计';
          return;
        }
        let values;
        if (column.property === 'weight') {
          values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = 'N/A';
          }
          return;
        }
        if (column.property === 'length') {
          values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = 'N/A';
          }
          return;
        }
      });
      return sums;
    },
    arraySpanMethod({ column }) {
      if (column.property === 'hubHeight') {
        return [10, 1];
      }
      if (column.property === 'basicInterfaceType') {
        return [10, 1];
      }
      if (column.property === 'towerMaterialSpecification') {
        return [10, 1];
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    unitTubeSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 3) {
          return {
            rowspan: 5,
            colspan: 1
          };
        } else if (rowIndex === 8) {
          return {
            rowspan: 5,
            colspan: 1
          };
        } else if (rowIndex === 13) {
          return {
            rowspan: 5,
            colspan: 1
          };
        } else if (rowIndex === 18) {
          return {
            rowspan: 5,
            colspan: 1
          };
        } else if (rowIndex === 23) {
          return {
            rowspan: 5,
            colspan: 1
          };
        } else if (rowIndex < 3) {
          return {
            rowspan: 1,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取部件详情
    async fetchGenerator() {
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      await this.$fetch('/windfarm/turbineType/getUnitGenerator', {
        params: {
          pointId: this.unitParams.id,
          type: this.unitParams.type
        },
        showError: true
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.unit) {
              this.tableLoading = false;
              return;
            }
            // if (this.unitParams.type === 4) {
            //   this.tubeInfo = res.data.unit.tube;
            //   res.data.unit.tubeDetail.sort(function(a, b) {
            //     let c = Number(a.tubeName.charAt(2));
            //     let d = Number(b.tubeName.charAt(2));
            //     return c - d;
            //   });
            //   this.tubeDetail = res.data.unit.tubeDetail;
            //   let i = res.data.unit.tubeDetail.length;
            //   do {
            //     i++;
            //     this.tubeDetail.push({
            //       tubeName: `塔筒${i}段`
            //     });
            //   } while (i < 10);
            //   this.tubeDetail.push({
            //     tubeName: '附件',
            //     weight: res.data.unit.tube.weightAccessories
            //   });
            // }
            if (this.unitParams.type === 4) {
              this.tubeInfo = res.data.unit.tube;
            }
            this.generatorInfo = res.data.unit;
            this.unitTableData = filterUnitTableData(
              res.data.unit,
              this.unitParams.type
            );
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 获取部件对比详情
    async fetchCompareInfo() {
      if (this.tableCompareLoading) {
        return;
      }
      this.tableCompareLoading = true;
      await this.$fetch('/windfarm/turbineType/getUnits', {
        params: {
          pointIds: this.unitIds.join(','),
          type: this.currentUnitType
        },
        showError: true
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.unitList) {
              this.tableCompareLoading = false;
              return;
            }
            if (this.currentUnitType !== 4) {
              this.unitTableCompareData = filterCompareUnit(
                res.data.unitList,
                this.currentUnitType
              );
            }

            if (this.currentUnitType === 4) {
              this.unitTableCompareData = filterCompareUnit4(res.data.unitList);
              this.tableList = res.data.unitList.map(item => {
                return item.tube;
              });
            } else {
              this.tableList = res.data.unitList;
            }
            this.tableCompareLoading = false;
          } else {
            this.tableCompareLoading = false;
          }
        })
        .catch(() => {
          this.tableCompareLoading = false;
        });
    },
    // 获取变流器详情
    async fetchConverter() {
      let data = await this.$fetch('/windfarm/turbineType/getUnitGenerator5', {
        params: {
          pointId: 1,
          type: 2
        }
      });
      this.generatorInfo = data.data.unit;
      this.unitTableData = filterUnitTableData(
        data.data.unit,
        this.unitParams.type
      );
    },
    // 获取叶片详情
    async fetchUnitBlade() {
      let data = await this.$fetch('/windfarm/turbineType/getUnitGenerator6', {
        params: {
          pointId: 1,
          type: 5
        }
      });
      this.generatorInfo = data.data.unit;
      this.unitTableData = filterUnitTableData(
        data.data.unit,
        this.unitParams.type
      );
    },
    async fetchUnitCable() {
      let data = await this.$fetch('/windfarm/turbineType/getUnitGenerator7', {
        params: {
          pointId: 1,
          type: 5
        }
      });
      this.generatorInfo = data.data.unit;
      this.unitTableData = filterUnitTableData(
        data.data.unit,
        this.unitParams.type
      );
    },
    async fetchUnitTube() {
      let data = await this.$fetch('/windfarm/turbineType/getUnitGenerator', {
        params: {
          pointId: 1,
          type: 4
        }
      });
      this.tubeInfo = data.data.unit.tube;
      data.data.unit.tubeDetail.sort(function(a, b) {
        let c = Number(a.tubeName.charAt(2));
        let d = Number(b.tubeName.charAt(2));
        return c - d;
      });
      this.tubeDetail = data.data.unit.tubeDetail;
      let i = data.data.unit.tubeDetail.length;
      do {
        i++;
        this.tubeDetail.push({
          tubeName: `塔筒${i}段`
        });
      } while (i < 10);
      this.tubeDetail.push({
        tubeName: '附件',
        weight: data.data.unit.tube.weightAccessories
      });
    }
  },
  mounted() {
    this.fetchGenerator();
  }
};
</script>

<style lang="less" scoped>
/deep/.dis {
  display: none !important;
  border-bottom: 0 !important;
  // border: 0 !important;
  // outline: none !important;
  // height: 0 !important;
}
.w-container {
  width: 100%;
  max-height: 100%;
  // padding-bottom: 20px;
  .el-table {
    max-height: 100%;
  }
  /deep/.el-table {
    overflow: visible !important;
  }
  /deep/.el-table__footer-wrapper > .el-table__footer tbody tr {
    background-color: #1e608f;
  }
  .top-title {
    width: 100%;
    height: 26px;
    line-height: 26px;
    color: white;
    background-color: #003e8e;
    padding-left: 30px;
    box-sizing: border-box;
    font-size: 13px;
  }
  .tube-detail {
    padding-bottom: 30px;
    padding-left: 20px;
    color: #fff;
    font-size: 12px;
    div:first-child {
      padding-top: 10px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.el-table th.gutter {
  display: table-cell !important;
  border-bottom: 0;
}
/deep/.el-table thead.is-group th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/ .el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.current-row > td {
  background-color: #0477a1;
}
/deep/.el-table__footer-wrapper tbody td,
.el-table__header-wrapper tbody td {
  background-color: #0477a1;
  color: #fff;
  text-align: center;
}
</style>
